const Nodo = ({ data }) => {

  const getColor = (tipo) => {
    switch (tipo) {
      case 0: return "#4CAF50";
      case 1: return "#FFC107";
      case 2: return "#F44336";
      default: return "#90A4AE";
    }
  };

    return (
        <div style={{ textAlign: "center" }}>
            
            <div
            style={{
                backgroundColor: getColor(data.tipo),
                padding: "10px",
                borderRadius: "8px",
                display: "inline-block",
                margin: "10px",
                minWidth: "140px"
            }}
            >
            <strong>{data.nombre}</strong>
            {data.cargo && <div>{data.cargo}</div>}
            </div>

            {data.children && (
            <div style={{ display: "flex", justifyContent: "center" }}>
                {data.children.map((child, index) => (
                <Nodo key={index} data={child} />
                ))}
            </div>
            )}

        </div>
    );
};

export default Nodo;